export const QA_NAME_MINIMIZED_MODAL_CLOSE_BTN = 'MinimizedModalCloseBtn'

export const QA_NAME_MINIMIZED_MODAL_RESTORE_BTN = 'MinimizedModalRestoreBtn'

export const QA_NAME_MINIMIZED_MODAL_ITEM = 'MinimizedModalItem'
